import React from "react";
import RegionBtn from "./RegionBtn";
import stateRegion from "../../state/state.region";
import { observer } from "mobx-react-lite";
import Media from "../../api/Media";

const FilterRegion = observer(() => {
  const setFilterRegion = (e) => {
    stateRegion.filterRegion(e.target.textContent);
  };
  return (
    <div
      className={
        !Media.mobile
          ? "btn_filter_region_company"
          : "btn_filter_region_company_mobile"
      }
    >
      {stateRegion.collectionRegion.map((r) => (
        <RegionBtn
          key={r.tag_country}
          onClick={setFilterRegion}
          btn={true}
          region={r.tag_country}
        />
      ))}
    </div>
  );
});

export default FilterRegion;
